import { Datalayer, DatalayersMap, DatalayerZone } from "../../../../omnia"
import { removeHoles } from "../deleteHoles"

export class MergeOperation {


    public invalid: boolean

    constructor(private map: DatalayersMap, private layer: Datalayer, private topo: omnia.map.IMapTopologyService, private selectedZonesProvider: () => DatalayerZone[]) {
    }

    start() {
        this.invalid = false
        this.map.enableMultipleSelection = true
    }

    stop() {
        this.invalid = false
        this.map.enableMultipleSelection = false
    }

    notifySelectionChanged() {
        this.invalid = false
    }

    public commit(): boolean {

        const { layer, topo } = this

        const selected = new Set(this.getSelectedZones())

        const isSelected = (z: DatalayerZone) => selected.has(z)

        const target = omnia.map.mergeZones(layer, isSelected, undefined, topo, zones => layer.removeZones(zones))

        this.invalid = !target

        if (target) {

            removeHoles(target, this.layer.zones, this.topo)

            return true

        }

    }

    canCommit(): boolean {
        return this.getSelectedZones().length > 1
    }

    private getSelectedZones() {
        return this.selectedZonesProvider() || []
    }


}
